exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-p[data-v-1bfece0c]{margin:0;color:#f05e61}.top-h[data-v-1bfece0c]{margin:0}.bottom-line[data-v-1bfece0c]{border-bottom:3px solid #eeeff2;padding-bottom:20px}@media only screen and (max-width:767px){h2.top-h[data-v-1bfece0c]{font-size:22px}p.top-h[data-v-1bfece0c]{font-size:10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1bfece0c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/top.vue
// module id = 360
// module chunks = 0